import { parseDateStringToDate } from "./utils/dateUtils";
import { getPathWithSlash } from "./utils/functional";

let holidays: Array<Date> = [];

const path = getPathWithSlash();

const get = (): Promise<Array<Date>> => {

    return new Promise((resolve, reject) => {

        if (holidays.length > 0) {
            resolve(holidays);
            return;
        }

        const url = path + "api/holidays";

        fetch(url)
            .then(res => res.json())
            .then((result: Array<string>) => {
                holidays = result.map(parseDateStringToDate);
                resolve(holidays);
            })
            .catch(_ => {
                reject("Could not load holidays from API");
            });
    });
}
const exports = {
    get
};

export default exports;